module.exports = __webpack_public_path__ + "assets/img/cheshen.13c34518.png";